import React from "react";
import { motion } from "framer-motion";

export default function Contact() {
  return (
    <section
      className="relative text-white flex flex-col min-h-screen px-4 text-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Background6.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Main Content Wrapper */}
      <div className="flex flex-col flex-grow items-center justify-center">
        <motion.h1
          className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-purple-400 mt-16 mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Get In Touch
        </motion.h1>

        <motion.p
          className="text-base md:text-xl mb-6 max-w-xl text-gray-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Have a question, project idea, or just want to say hi? Feel free to reach out — I’m always open to connecting!
        </motion.p>

        <motion.div
          className="space-y-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
        >
          <p className="text-lg md:text-xl">
            📧{" "}
            <a
              href="mailto:mithil.peeris@gmail.com"
              className="text-purple-400 hover:underline"
            >
              mithil.peeris@gmail.com
            </a>
          </p>
          <p className="text-lg md:text-xl">
            📞{" "}
            <a
              href="tel:+14373293046"
              className="text-purple-400 hover:underline"
            >
              +1 (437) 329-3046
            </a>
          </p>

          <div className="flex justify-center space-x-6 md:space-x-8">
            <a
              href="https://www.linkedin.com/in/mithil-peeris-285529288/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-purple-400 text-2xl md:text-3xl transition"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/MithilPeeris"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-purple-400 text-2xl md:text-3xl transition"
            >
              <i className="fab fa-github"></i>
            </a>
            <a
              href="https://www.instagram.com/mithil_peeris"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-purple-400 text-2xl md:text-3xl transition"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </motion.div>
      </div>

    </section>
  );
}
